import ConfiguredScreenShare from './configured-screen-share'

import { reducer } from './screen-share-redux'

export { ConfiguredScreenShare, reducer as screenShareReducer }
